module.exports = __webpack_public_path__ + "statics/img/Invitation-under-review-logo.71da4b06.png";